"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Box_1 = require("../Box");
var AccordionContext_1 = require("./AccordionContext");
var activeAsArray = function (active) { return (typeof active === 'number' ? [active] : active); }; // function component
var Accordion = /** @class */ (function (_super) {
    tslib_1.__extends(Accordion, _super);
    function Accordion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeIndexes: []
        };
        _this.onPanelChange = function (event, index) {
            event.preventDefault();
            var activeIndexes = _this.state.activeIndexes;
            var nextActiveIndexes = tslib_1.__spreadArrays((activeIndexes || []));
            var _a = _this.props, onActive = _a.onActive, multiple = _a.multiple;
            var activeIndex = nextActiveIndexes.indexOf(index);
            if (activeIndex > -1) {
                nextActiveIndexes.splice(activeIndex, 1);
            }
            else if (multiple) {
                nextActiveIndexes.push(index);
            }
            else {
                nextActiveIndexes = [index];
            }
            _this.setState({ activeIndexes: nextActiveIndexes }, function () {
                if (onActive) {
                    onActive(nextActiveIndexes);
                }
            });
        };
        return _this;
    }
    Accordion.getDerivedStateFromProps = function (nextProps, prevState) {
        var activeIndex = nextProps.activeIndex;
        var stateActiveIndexes = prevState.activeIndexes, stateActiveIndex = prevState.activeIndex;
        var activeIndexes = activeAsArray(activeIndex) || [];
        if ((typeof activeIndex !== 'undefined' || activeIndex !== stateActiveIndex) &&
            activeIndexes.join() !== stateActiveIndexes.join()) {
            return { activeIndexes: activeIndexes, activeIndex: activeIndex };
        }
        return null;
    };
    Accordion.prototype.render = function () {
        var _this = this;
        var _a = this.props, animate = _a.animate, children = _a.children, messages = _a.messages, rest = tslib_1.__rest(_a, ["animate", "children", "messages"]);
        var activeIndexes = this.state.activeIndexes;
        delete rest.onActive;
        return (React.createElement(Box_1.Box, tslib_1.__assign({ role: "tablist" }, rest), React.Children.toArray(children).map(function (panel, index) { return (React.createElement(AccordionContext_1.AccordionContext.Provider, { key: "accordion-panel_" + (index + 0), value: {
                active: activeIndexes.indexOf(index) > -1,
                animate: animate,
                messages: messages,
                onPanelChange: function (event) { return _this.onPanelChange(event, index); }
            } }, panel)); })));
    };
    Accordion.defaultProps = {
        animate: true,
        messages: {
            tabContents: 'Tab Contents'
        }
    };
    return Accordion;
}(React.Component));
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map